import VehiclesError from './VehiclesError.js'

export class GetModelDetailContentError extends VehiclesError {}
